import { PILLAR } from "../../enums/metrics";
import type { MetricDef } from "./types";

/** AI Reference family: will AI systems ingest, quote and get this page right? */
export const AI_REFERENCE_METRICS = [
  {
    key: "inclusion",
    label: "AI Inclusion",
    pillar: PILLAR.AI_REFERENCE,
    target: 85,
    good: 70,
    watch: 45,
    description:
      "Whether AI systems can ingest the page at all: robots.txt admitting major AI crawlers, main content present without JS execution, an llms.txt guide and no interaction gate blocking the content.",
  },
  {
    key: "source_control",
    label: "Source Control",
    pillar: PILLAR.AI_REFERENCE,
    target: 85,
    good: 70,
    watch: 45,
    description:
      "Whether the brand owns its own story: a self-referencing canonical, Organization structured data identifying the brand, consistent identity and key content served first-party.",
  },
  {
    key: "prominence",
    label: "Prominence",
    pillar: PILLAR.AI_REFERENCE,
    target: 85,
    good: 70,
    watch: 45,
    description:
      "Whether the content is quotable by an answer engine: declarative standalone facts, question-phrased headings, a liftable summary and unambiguous entity naming.",
  },
  {
    key: "accuracy",
    label: "Accuracy",
    pillar: PILLAR.AI_REFERENCE,
    target: 85,
    good: 70,
    watch: 45,
    description:
      "Whether a quoted fact would be right: no internal contradictions, structured data agreeing with visible content, absolute dates and numbers, and attributed claims.",
  },
  {
    key: "competitor_leakage",
    label: "Competitor Leakage",
    pillar: PILLAR.AI_REFERENCE,
    target: 85,
    good: 70,
    watch: 45,
    description:
      "Whether AI assistants answer brand queries with competitor content. Needs external assistant probes the page-scoped agent cannot run honestly, so it ships with zero checks and is never scored in v0 — explicitly unscored beats invented precision.",
  },
] as const satisfies readonly MetricDef[];
